var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var OrganizationsModel = GenericModel.extend(
{
    urlRoot : '/rest/api/organizations',
    id : null,
    title : "",
    description : "",
    tellodyApiKey: ""

});

module.exports = OrganizationsModel;